import React from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { ChangelogIcon, HelpCenterIcon } from "@icons";
import { HelpMenu } from "./HelpMenu";
import { CHANGELOG_URL, HELP_CENTER_URL } from "./helpMenuLinks";

export const SupportChat: React.FC = () => (
    <HelpMenu>
        <Menu.LinkItem
            href={HELP_CENTER_URL}
            target="_blank"
            leading={<HelpCenterIcon />}
        >
            Help center
        </Menu.LinkItem>
        <Menu.LinkItem
            href={CHANGELOG_URL}
            target="_blank"
            leading={<ChangelogIcon />}
        >
            Changelog
        </Menu.LinkItem>
    </HelpMenu>
);
